import _ from 'underscore';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Modal from 'components/Modal';

import styles from './styles.module.scss';

const withAuthorization = ({ text, onButtonClick }) => (WrappedComponent) => {
	const WithAuthorization = ({ onClick, ...props }) => {
		const [showModal, setShowModal] = useState(false);
		const { currentUser } = useSelector((state) => state.currentUser);
		const isAuthUser = !!currentUser;

		const onClickHandler = useCallback(() => {
			if (currentUser) {
				onClick();
			} else {
				setShowModal(true);
			}
		}, [isAuthUser, onClick]);

		const onAuthButtonClick = useCallback(() => {
			onButtonClick();

			window.location.href = `/authorization/login?returnTo=${window.location.href}`;
		}, [onButtonClick]);

		const closeModal = useCallback(() => setShowModal(false), []);

		const renderModal = () => (
			<Modal
				onRequestClose={closeModal}
				isShowModal={showModal}
				header="Авторизация"
				size="medium"
			>
				<div className={styles.notice}>
					<div className={styles.title}>{text}</div>
					<div className={styles.controls}>
						<Button title="Войти" onClick={onAuthButtonClick} />
					</div>
				</div>
			</Modal>
		);

		return (
			<>
				<WrappedComponent {...props} onClick={onClickHandler} />
				{showModal && renderModal()}
			</>
		);
	};

	WithAuthorization.propTypes = {
		onClick: PropTypes.func
	};

	WithAuthorization.defaultProps = {
		onClick: _.noop
	};

	return WithAuthorization;
};

export default withAuthorization;
